import { numberWithCommas, unlimitedParse } from '@callrail/looky/util';

import { platformDisplayInfo } from '../interfaces/plan-display-info';
import { PlatformPricing } from '../interfaces/platform-pricing';
import { ProductType } from '../type-aliases/product-type';
import { PlatformModel } from './platform.model';

export class ConversationIntelligencePlatformModel extends PlatformModel {
  public minutes: PlatformPricing;
  public uom?: string;

  public platform: ProductType = 'conversation_intelligence';
  public platformInfo = platformDisplayInfo[this.platform];

  public displayText;

  constructor(platformPlan) {
    super(platformPlan);
    Object.assign(this, platformPlan);
    this.setDisplayText();
  }

  public get _usageInfo(): string[] {
    return [
      `${this.minutes.included_units} transcription minutes per month; \
      $${this.minutes.additional_price} each additional`,
    ];
  }

  public get _unitPrice(): number {
    return this.price;
  }

  private setDisplayText() {
    this.displayText = {
      marketingCopyA: `${numberWithCommas(
        unlimitedParse(this.minutes?.included_units)
      )} included local call transcription minutes`,
      marketingCopyB: `Automation Rules`,
      marketingCopyC: `Keyword analysis`,
    };
  }
}
